@if (svc.banners().length > 0) {
  <div class="system-banner-stack" role="status" aria-live="polite">
    @for (banner of svc.banners(); track banner.id) {
      <div class="system-banner" [attr.data-severity]="banner.severity">
        <mat-icon class="system-banner__icon">{{ iconFor(banner.severity) }}</mat-icon>
        <span class="system-banner__message">{{ banner.message }}</span>
        @if (banner.action) {
          <button
            mat-flat-button
            color="primary"
            class="system-banner__action"
            (click)="banner.action.callback()"
          >
            {{ banner.action.label }}
          </button>
        }
        @if (banner.dismissible !== false) {
          <button
            mat-icon-button
            class="system-banner__dismiss"
            aria-label="Dismiss notification"
            (click)="svc.dismiss(banner.id)"
          >
            <mat-icon>close</mat-icon>
          </button>
        }
      </div>
    }
  </div>
}
